import { Subject } from 'rxjs';

import type { RegularCall, TeamingRequest } from 'features/rns/interfaces';

export class ConferenceEventBus {
  static $newCall = new Subject<RegularCall>();
  static $teamingRequest = new Subject<TeamingRequest>();
}
